import { jsx, jsxs } from "react/jsx-runtime";
import Facebook from "@crehana/compass.icons.fill/Facebook";
import Linkedin from "@crehana/compass.icons.fill/Linkedin";
import Twitter from "@crehana/compass.icons.fill/Twitter";
import Instagram from "@crehana/icons/Instagram";
import Youtube from "@crehana/icons/Youtube";
import { Col, Row } from "@crehana/ui";
import { clsx } from "clsx";
import Lazyload from "../../../Lazyload/index.js";
import Loadable from "../../../Loadable/index.js";
import AppsColumn from "../../components/AppsColumn.js";
import CurrencyLoader from "../../components/CurrencyLoader.js";
import Copyright from "./Copyright.js";
import SocialLink from "./SocialLink.js";
const BottomSection = ({ isDark, shouldHideCurrencySelector = false, shouldHideAppsColumn = false })=>/*#__PURE__*/ jsxs(Row, {
        className: "tw-flex tw-items-center tw-pb-3.2 sm:tw-pb-4.8 lg:tw-pb-6.4 md:tw-items-end lg:tw-items-center",
        children: [
            /*#__PURE__*/ jsx(Copyright, {
                isDark: isDark,
                className: "tw-hidden md:tw-block"
            }),
            !shouldHideAppsColumn && /*#__PURE__*/ jsx(AppsColumn, {
                isDark: isDark,
                className: "tw-flex tw-flex-col tw-items-center tw-mb-2.4 md:tw-hidden sm:tw-mb-0 sm:tw-items-start"
            }),
            /*#__PURE__*/ jsxs(Col, {
                sm: 5,
                md: 4,
                lg: 6,
                offset: {
                    sm: 1,
                    md: 0
                },
                nowrap: true,
                className: "tw-flex tw-flex-col tw-items-center tw-self-end tw-justify-end sm:tw-items-start md:tw-items-end lg:tw-items-center lg:tw-flex-row",
                children: [
                    /*#__PURE__*/ jsxs("span", {
                        className: clsx('md:tw-mr-1.2 tw-flex tw-text-neutral-light-700 dark:tw-text-neutral-dark-100', !shouldHideCurrencySelector && 'tw-mb-2.4 sm:tw-mb-3.2 md:tw-mb-2.4 lg:tw-mb-0'),
                        children: [
                            /*#__PURE__*/ jsx(SocialLink, {
                                link: "https://www.facebook.com/Crehanacom/",
                                icon: Facebook
                            }),
                            /*#__PURE__*/ jsx(SocialLink, {
                                link: "https://twitter.com/crehanacom",
                                icon: Twitter
                            }),
                            /*#__PURE__*/ jsx(SocialLink, {
                                link: "https://www.instagram.com/crehanacom/",
                                icon: Instagram
                            }),
                            /*#__PURE__*/ jsx(SocialLink, {
                                link: "https://www.linkedin.com/school/crehana/",
                                icon: Linkedin
                            }),
                            /*#__PURE__*/ jsx(SocialLink, {
                                link: "https://www.youtube.com/channel/UCg6_yPdtalblZ0Peqjv5rPg/featured",
                                icon: Youtube
                            })
                        ]
                    }),
                    !shouldHideCurrencySelector && /*#__PURE__*/ jsx(Lazyload, {
                        children: /*#__PURE__*/ jsx(Loadable, {
                            module: ()=>import("../../components/CurrencyDropdownSelector.js"),
                            Loader: /*#__PURE__*/ jsx(CurrencyLoader, {}),
                            isDark: isDark
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Copyright, {
                isDark: isDark,
                className: "md:tw-hidden"
            })
        ]
    });
const BottomSection_BottomSection = BottomSection;
export default BottomSection_BottomSection;
